export default __webpack_public_path__ + "static/media/bg1.7bb511ad.svg";